import React from "react";
import {SecondaryCollapsibleSection} from "../../../../../../elements/collapsableSection/secondary/SecondaryCollapsibleSection";
import {ValidatedInputField} from "../../../../../../elements/validator/component/ValidatedInputField";
import {NotEmptyStringValidator} from "../../../../../../elements/validator/Validator";
import {ValidationResult} from "../../../../../../elements/validator/component/ValidationComponent";
import {UpdateBotToolSettingsRequest} from "../../../../../../../api/generated";
import {useAppDispatch} from "../../../../../../../app/hooks";
import {selectLocationQuoteeId, updateLocationQuoteeId} from "../../toolSettingsSlice";
import styles from "./LocationQuoteeIdsTable.module.css";

interface LocationQuoteeId {
    locationPublicId?: string;
    locationName?: string;
    quoteeId?: string;
}

interface LocationQuoteeIdsTableProps {
    locationQuoteeIds: LocationQuoteeId[];
    disabled?: boolean;
    updateValidationStatus: (status: ValidationResult<UpdateBotToolSettingsRequest>) => void;
    getMessage: (f: string) => string;
}

export const LocationQuoteeIdsTable: React.FC<LocationQuoteeIdsTableProps> = ({
    locationQuoteeIds,
    disabled,
    updateValidationStatus,
    getMessage
}) => {
    const dispatch = useAppDispatch();

    if (!locationQuoteeIds || locationQuoteeIds.length === 0) {
        return null;
    }

    return (
        <SecondaryCollapsibleSection title="Quotee IDs by Location" disabled={disabled}>
            <div className={styles.table}>
                <div className={styles.headerRow}>
                    <div className={styles.headerCell}>Location</div>
                    <div className={styles.headerCell}>Quotee ID</div>
                </div>
                {locationQuoteeIds.map((loc) => (
                    <div key={loc.locationPublicId} className={styles.row}>
                        <div className={styles.labelCell}>
                            {loc.locationName || 'Unknown Location'}
                        </div>
                        <div className={styles.inputCell}>
                            <ValidatedInputField<string, UpdateBotToolSettingsRequest>
                                required={false}
                                onChange={(v) => dispatch(updateLocationQuoteeId({
                                    locationPublicId: loc.locationPublicId || '',
                                    quoteeId: v || ''
                                }))}
                                updateValidationStatus={updateValidationStatus}
                                fieldName={`ivendiProviderConfig.locationQuoteeIds.${loc.locationPublicId || 'unknown'}.quoteeId`}
                                selector={selectLocationQuoteeId(loc.locationPublicId || '')}
                                validator={NotEmptyStringValidator}
                                disabled={disabled}
                                label={''}
                                placeholder="Enter Quotee ID"
                                getMessage={getMessage}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </SecondaryCollapsibleSection>
    );
};
